/* eslint-disable prettier/prettier */
const mockApiResponses = {
  'api/rope/project/5988': {
    isEligible: false,
    isProcessed: false,
    sheetDetails: []
  },
  'api/rope/project/5539': {
    isEligible: true,
    isProcessed: false,
    sheetDetails: [
      {
        version: 1.1,
        created_by: 'abcd@asdas.com',
        created_at: '2026-02-20',
        comment: 'This is the temporary first version of the project, which includes the initial set of features and functionalities as outlined in the project scope.',
        message: 'Uploaded on the specified date and ready for initial review and feedback from the team.'
      },
      {
        version: 1.2,
        created_by: 'efgh@asdas.com',
        created_at: '2026-03-21',
        comment: 'This version includes minor bug fixes that address issues reported by early users during the initial testing phase.',
        message: 'Uploaded on the specified date with all known bugs fixed and is now more stable for further testing.'
      },
      {
        version: 1.3,
        created_by: 'ijkl@asdas.com',
        created_at: '2026-04-22',
        comment: 'Added several new features to enhance user experience, including new navigation options and improved performance.',
        message: 'Uploaded on the specified date with new features ready for user testing and feedback.'
      },
      {
        version: 1.4,
        created_by: 'mnop@asdas.com',
        created_at: '2026-05-23',
        comment: 'Performance improvements have been made to ensure faster load times and a smoother user experience.',
        message: 'Uploaded on the specified date with performance enhancements implemented and tested.'
      },
      {
        version: 2.1,
        created_by: 'qrst@asdas.com',
        created_at: '2026-06-24',
        comment: 'UI enhancements have been made to improve the overall look and feel of the application, making it more user-friendly.',
        message: 'Uploaded on the specified date with updated UI elements and design improvements.'
      },
      {
        version: 2.2,
        created_by: 'uvwx@asdas.com',
        created_at: '2026-07-25',
        comment: 'Fixed several security issues to ensure the application is secure and protected against potential threats.',
        message: 'Uploaded on the specified date with all security vulnerabilities addressed.'
      },
      {
        version: 2.3,
        created_by: 'yzab@asdas.com',
        created_at: '2026-08-26',
        comment: 'Introduced a new module that adds significant functionality to the application, expanding its capabilities.',
        message: 'Uploaded on the specified date with the new module fully integrated and ready for use.'
      },
      {
        version: 2.4,
        created_by: 'cdef@asdas.com',
        created_at: '2026-09-27',
        comment: 'Patch release to address minor issues and improve overall stability of the application.',
        message: 'Uploaded on the specified date with patches applied to resolve minor issues.'
      },
      {
        version: 2.5,
        created_by: 'ghij@asdas.com',
        created_at: '2026-10-28',
        comment: 'Major update with new features, enhancements, and performance improvements to provide a better user experience.',
        message: 'Uploaded on the specified date with major updates and new features ready for deployment.'
      },
      {
        version: 2.6,
        created_by: 'klmn@asdas.com',
        created_at: '2026-11-29',
        comment: 'Hotfix for a critical issue that was identified in the previous version, ensuring the application runs smoothly.',
        message: 'Uploaded on the specified date with the critical issue resolved and the application stabilized.'
      }
    ]
  },
  'api/rope/project/5503': {
    isEligible: true,
    isProcessed: true,
    sheetDetails: [
      {
        version: 1.1,
        created_by: 'abcd@asdas.com',
        created_at: '2026-02-20',
        comment: 'This is the temporary first version of the project, which includes the initial set of features and functionalities as outlined in the project scope.',
        message: 'Uploaded on the specified date and ready for initial review and feedback from the team.'
      },
      {
        version: 1.2,
        created_by: 'efgh@asdas.com',
        created_at: '2026-03-21',
        comment: 'This version includes minor bug fixes that address issues reported by early users during the initial testing phase.',
        message: 'Uploaded on the specified date with all known bugs fixed and is now more stable for further testing.'
      },
      {
        version: 1.3,
        created_by: 'ijkl@asdas.com',
        created_at: '2026-04-22',
        comment: 'Added several new features to enhance user experience, including new navigation options and improved performance.',
        message: 'Uploaded on the specified date with new features ready for user testing and feedback.'
      },
      {
        version: 2.1,
        created_by: 'mnop@asdas.com',
        created_at: '2026-05-23',
        comment: 'Performance improvements have been made to ensure faster load times and a smoother user experience.',
        message: 'Uploaded on the specified date with performance enhancements implemented and tested.'
      },
      {
        version: 2.2,
        created_by: 'qrst@asdas.com',
        created_at: '2026-06-24',
        comment: 'UI enhancements have been made to improve the overall look and feel of the application, making it more user-friendly.',
        message: 'Sheet is processed'
      }
    ]
  },
  'api/projects/5539': {
    "id": 5539,
    "name": "McDonald's - Business Development",
    "startDate": "2022-01-01",
    "endDate": "2030-12-31",
    "client": {
        "id": 791,
        "name": "McDonald's Global Business Services"
    },
    "engagementName": "McDonald's - Business Development",
    "employees": [],
    "active": true,
    "isROPEEligible": true
  },
  'api/rope-projects/all': [   {
    "a": 802,
    "b": "Triumph Business Capital",
    "c": "Dallas",
    "d": "2022 Strategic Initiatives",
    "e": 1863,
    "f": "Decision Science",
    "g": "2018-12-03",
    "h": "2019-12-31",
    "i": "6:Delivery",
    "j": 3103,
    "k": "Alyse White",
    "l": 3103,
    "m": "Alyse White",
    "n": 3762,
    "o": "Pete Gekas",
    "p": true,
    "q": "D&A",
    "r": "",
    "t": "1.3"
},
{
    "a": 932,
    "b": "Global > Global Delivery Center",
    "c": "X Internal NonBillable US",
    "d": "2023 GDC",
    "e": 5490,
    "f": "2023 GDC > Bench",
    "g": "2019-04-01",
    "h": "2024-12-31",
    "i": "8:Closed",
    "j": 5138,
    "k": "Ajay Dattanarayana",
    "l": 5433,
    "m": "Manan Bhandari",
    "n": 5138,
    "o": "Ajay Dattanarayana",
    "p": true,
    "q": "",
    "r": "2023R1436-001",
    "t": "1.16"
},
{
    "a": 897,
    "b": "Internal > Diversity, Equity & Inclusion",
    "c": "X Internal NonBillable US",
    "d": "2023 ERGs",
    "e": 5895,
    "f": "ERGs > Open Pride Credera (OPC)",
    "g": "2020-01-01",
    "h": "2023-12-31",
    "i": "8:Closed",
    "j": 4630,
    "k": "Rhea Horton",
    "l": 5007,
    "m": "Antonio King",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "2023R1556-006",
    "t": "1.9"
},
{
    "a": 818,
    "b": "Farmers Alliance Mutual Insurance",
    "c": "Dallas",
    "d": "Farmers Alliance Mutual Insurance - Business Development",
    "e": 5631,
    "f": "Farmers Alliance Mutual Insurance - Business Development",
    "g": "2020-01-31",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 3381,
    "k": "Gail Stout Perry",
    "l": 3270,
    "m": "Christian Buechel",
    "n": 3381,
    "o": "Gail Stout Perry",
    "p": true,
    "q": "",
    "r": "CRED-P00100229",
    "t": "1.4"
},
{
    "a": 408,
    "b": "TargetBase",
    "c": "Dallas",
    "d": "TargetBase - Business Development",
    "e": 5751,
    "f": "TargetBase - Business Development",
    "g": "2020-09-28",
    "h": "2023-12-31",
    "i": "6:Delivery",
    "j": 3807,
    "k": "Rick Gipson",
    "l": 3807,
    "m": "Rick Gipson",
    "n": 3807,
    "o": "Rick Gipson",
    "p": true,
    "q": "",
    "r": "CRED-P00100132",
    "t": "1.19"
},
{
    "a": 913,
    "b": "Internal > Operations Enablement",
    "c": "X Internal NonBillable US",
    "d": "2023 Project Cobbler",
    "e": 5380,
    "f": "Project Cobbler",
    "g": "2021-02-01",
    "h": "2026-06-30",
    "i": "8:Closed",
    "j": 3648,
    "k": "Marleta Hansen",
    "l": 3822,
    "m": "Ryan Crews",
    "n": 3573,
    "o": "Kevin Erickson",
    "p": true,
    "q": "",
    "r": "R1716-001",
    "t": "1.3"
},
{
    "a": 238,
    "b": "Southwest Airlines",
    "c": "Dallas",
    "d": "IDM IAM Acceleration",
    "e": 2834,
    "f": "IDM IAM Acceleration",
    "g": "2021-03-01",
    "h": "2023-08-31",
    "i": "8:Closed",
    "j": 4142,
    "k": "Caitlin Kernander",
    "l": 4142,
    "m": "Caitlin Kernander",
    "n": 4228,
    "o": "Lu Truong",
    "p": true,
    "q": "MC | Program Leadership",
    "r": "R1218-001",
    "t": "1.15"
},
{
    "a": 897,
    "b": "Internal > Diversity, Equity & Inclusion",
    "c": "X Internal NonBillable US",
    "d": "2023 ERGs",
    "e": 5900,
    "f": "ERGs > CredColor",
    "g": "2021-05-03",
    "h": "2023-12-31",
    "i": "8:Closed",
    "j": 4630,
    "k": "Rhea Horton",
    "l": 3207,
    "m": "Bria Ford",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "2023R1556-002",
    "t": "1.16"
},
{
    "a": 795,
    "b": "Raising Cane's",
    "c": "Dallas",
    "d": "Raising Cane's - Business Development",
    "e": 5720,
    "f": "Raising Cane's - Business Development",
    "g": "2021-06-03",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 3283,
    "k": "Cody Case",
    "l": 3283,
    "m": "Cody Case",
    "n": 3283,
    "o": "Cody Case",
    "p": true,
    "q": "",
    "r": "R1803-001",
    "t": "1.3"
},
{
    "a": 238,
    "b": "Southwest Airlines",
    "c": "Dallas",
    "d": "Inflight Wifi Modernization",
    "e": 2975,
    "f": "Inflight Wifi Modernization",
    "g": "2021-06-21",
    "h": "2024-06-30",
    "i": "6:Delivery",
    "j": 3876,
    "k": "Shawn Anderson",
    "l": 3563,
    "m": "Kelsey Kah",
    "n": 3352,
    "o": "Emily Schulhoff",
    "p": true,
    "q": "MC",
    "r": "R1219-001",
    "t": "1.15"
},
{
    "a": 892,
    "b": "Offices > Denver",
    "c": "Denver",
    "d": "2023 Denver",
    "e": 5409,
    "f": "2023 Denver > Denver Startup Week",
    "g": "2021-07-13",
    "h": "2025-12-31",
    "i": "8:Closed",
    "j": 3195,
    "k": "Brad Krumwiede",
    "l": 4101,
    "m": "Anat Fraenkel",
    "n": 3110,
    "o": "Amanda Leachman",
    "p": true,
    "q": "",
    "r": "2023R1597-005",
    "t": "1.17"
},
{
    "a": 897,
    "b": "Internal > Diversity, Equity & Inclusion",
    "c": "X Internal NonBillable US",
    "d": "2023 ERGs",
    "e": 5897,
    "f": "ERGs > Credera Veteran's Network",
    "g": "2021-11-01",
    "h": "2024-01-05",
    "i": "8:Closed",
    "j": 4630,
    "k": "Rhea Horton",
    "l": 4111,
    "m": "Thad Siwinski",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "2023R1556-004",
    "t": "1.12"
},
{
    "a": 812,
    "b": "Global > Areteans US",
    "c": "X Internal NonBillable US",
    "d": "Credera US Support",
    "e": 4521,
    "f": "Credera US Support > General",
    "g": "2021-11-01",
    "h": "2025-12-31",
    "i": "8:Closed",
    "j": 3152,
    "k": "Ashley Coleman",
    "l": 3152,
    "m": "Ashley Coleman",
    "n": 5286,
    "o": "Dennis Schumacher",
    "p": true,
    "q": "",
    "r": "2023 R1382-001",
    "t": "1.5"
},
{
    "a": 238,
    "b": "Southwest Airlines",
    "c": "Dallas",
    "d": "EIDT MFA",
    "e": 3333,
    "f": "EIDT MFA",
    "g": "2021-12-03",
    "h": "2023-04-28",
    "i": "8:Closed",
    "j": 4690,
    "k": "Brandon Upchurch",
    "l": 4690,
    "m": "Brandon Upchurch",
    "n": 4228,
    "o": "Lu Truong",
    "p": true,
    "q": "MC",
    "r": "R1217-001",
    "t": "1.6"
},
{
    "a": 788,
    "b": "7-Eleven, Inc.",
    "c": "Dallas",
    "d": "7-Eleven - Business Development",
    "e": 5633,
    "f": "7-Eleven - Business Development",
    "g": "2022-01-01",
    "h": "2024-12-10",
    "i": "6:Delivery",
    "j": 3381,
    "k": "Gail Stout Perry",
    "l": 3381,
    "m": "Gail Stout Perry",
    "n": 3381,
    "o": "Gail Stout Perry",
    "p": true,
    "q": "",
    "r": "R1251-001",
    "t": "1.13"
},
{
    "a": 909,
    "b": "ALS Group",
    "c": "Houston",
    "d": "ALS - Business Development",
    "e": 5634,
    "f": "ALS - Business Development",
    "g": "2022-01-01",
    "h": "2024-12-10",
    "i": "6:Delivery",
    "j": 3381,
    "k": "Gail Stout Perry",
    "l": 3381,
    "m": "Gail Stout Perry",
    "n": 3381,
    "o": "Gail Stout Perry",
    "p": true,
    "q": "",
    "r": "R1260-001",
    "t": "1.12"
},
{
    "a": 703,
    "b": "Cox Automotive",
    "c": "Atlanta",
    "d": "Cox Automotive - Business Development",
    "e": 5892,
    "f": "Cox Automotive - Business Development",
    "g": "2022-01-01",
    "h": "2024-12-18",
    "i": "6:Delivery",
    "j": 3807,
    "k": "Rick Gipson",
    "l": 3807,
    "m": "Rick Gipson",
    "n": 3807,
    "o": "Rick Gipson",
    "p": true,
    "q": "",
    "r": "R1284-001",
    "t": "1.5"
},
{
    "a": 816,
    "b": "Title Resources Guaranty Company",
    "c": "Houston",
    "d": "Title Resources Guaranty Company - Business Development",
    "e": 5893,
    "f": "Title Resources Group - Business Development",
    "g": "2022-01-01",
    "h": "2024-09-06",
    "i": "6:Delivery",
    "j": 4512,
    "k": "Zach Vinduska",
    "l": 4450,
    "m": "Mario DiMattia",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "P001374-001",
    "t": "1.10"
},
{
    "a": 636,
    "b": "Care.com",
    "c": "New York City",
    "d": "Care.com - Business Development",
    "e": 5383,
    "f": "Care.com - Business Development",
    "g": "2022-01-01",
    "h": "2024-09-09",
    "i": "6:Delivery",
    "j": 3573,
    "k": "Kevin Erickson",
    "l": 3573,
    "m": "Kevin Erickson",
    "n": 3573,
    "o": "Kevin Erickson",
    "p": true,
    "q": "",
    "r": "R1276-001",
    "t": "1.15"
},
{
    "a": 897,
    "b": "Internal > Diversity, Equity & Inclusion",
    "c": "X Internal NonBillable US",
    "d": "2023 ERGs",
    "e": 5896,
    "f": "ERGs > CredAbility",
    "g": "2022-01-01",
    "h": "2023-12-31",
    "i": "8:Closed",
    "j": 4630,
    "k": "Rhea Horton",
    "l": 4630,
    "m": "Rhea Horton",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "2023R1556-001",
    "t": "1.19"
},
{
    "a": 897,
    "b": "Internal > Diversity, Equity & Inclusion",
    "c": "X Internal NonBillable US",
    "d": "2023 ERGs",
    "e": 5899,
    "f": "ERGs > CrederaThrive",
    "g": "2022-01-01",
    "h": "2023-12-31",
    "i": "8:Closed",
    "j": 4630,
    "k": "Rhea Horton",
    "l": 3528,
    "m": "Joshua Grear",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "2023R1556-003",
    "t": "1.15"
},
{
    "a": 546,
    "b": "Novartis",
    "c": "New York City",
    "d": "ATOMIC 2022",
    "e": 3341,
    "f": "ATOMIC 2022",
    "g": "2022-01-01",
    "h": "2023-03-24",
    "i": "8:Closed",
    "j": 3270,
    "k": "Christian Buechel",
    "l": 3270,
    "m": "Christian Buechel",
    "n": 3717,
    "o": "Nate Raymond",
    "p": true,
    "q": "MC | Program Leadership",
    "r": "R0150-001",
    "t": "1.14"
},
{
    "a": 815,
    "b": "Argonne National Laboratory",
    "c": "Chicago",
    "d": "Argonne National Laboratory - Business Development",
    "e": 5914,
    "f": "Argonne National Laboratory - Business Development",
    "g": "2022-01-01",
    "h": "2024-11-20",
    "i": "6:Delivery",
    "j": 3736,
    "k": "Nickoria Johnson",
    "l": 3736,
    "m": "Nickoria Johnson",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "R1811-001",
    "t": "1.12"
},
{
    "a": 502,
    "b": "Invitation Homes",
    "c": "Dallas",
    "d": "Invitation Homes - Business Development",
    "e": 5915,
    "f": "Invitation Homes - Business Development",
    "g": "2022-01-01",
    "h": "2024-11-08",
    "i": "6:Delivery",
    "j": 3736,
    "k": "Nickoria Johnson",
    "l": 3736,
    "m": "Nickoria Johnson",
    "n": 3736,
    "o": "Nickoria Johnson",
    "p": true,
    "q": "",
    "r": "R1764-001",
    "t": "1.9"
},
{
    "a": 689,
    "b": "Parsons",
    "c": "Dallas",
    "d": "Parsons - Business Development",
    "e": 5412,
    "f": "Parsons - Business Development",
    "g": "2022-01-01",
    "h": "2024-02-14",
    "i": "6:Delivery",
    "j": 3110,
    "k": "Amanda Leachman",
    "l": 3110,
    "m": "Amanda Leachman",
    "n": 3110,
    "o": "Amanda Leachman",
    "p": true,
    "q": "",
    "r": "R1338-001",
    "t": "1.6"
},
{
    "a": 789,
    "b": "U.S. Army",
    "c": "Chicago",
    "d": "US Army - Business Development",
    "e": 5416,
    "f": "US Army - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-30",
    "i": "6:Delivery",
    "j": 3437,
    "k": "Jared Pelley",
    "l": 3437,
    "m": "Jared Pelley",
    "n": 3437,
    "o": "Jared Pelley",
    "p": true,
    "q": "",
    "r": "R1310-001",
    "t": "1.13"
},
{
    "a": 794,
    "b": "NRG Energy Inc.",
    "c": "Houston",
    "d": "NRG Energy Inc. - Business Development",
    "e": 5932,
    "f": "NRG Energy Inc. - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-17",
    "i": "6:Delivery",
    "j": 3064,
    "k": "Aaron Grotzinger",
    "l": 3064,
    "m": "Aaron Grotzinger",
    "n": 3064,
    "o": "Aaron Grotzinger",
    "p": true,
    "q": "",
    "r": "R1334-001",
    "t": "1.18"
},
{
    "a": 728,
    "b": "Sunnova Energy International",
    "c": "Houston",
    "d": "Sunnova Energy International - Business Development",
    "e": 5933,
    "f": "Sunnova Energy International - Business Development",
    "g": "2022-01-01",
    "h": "2024-09-16",
    "i": "6:Delivery",
    "j": 3064,
    "k": "Aaron Grotzinger",
    "l": 4381,
    "m": "Dbrav Dunkley",
    "n": 3064,
    "o": "Aaron Grotzinger",
    "p": true,
    "q": "",
    "r": "R1361-001",
    "t": "1.13"
},
{
    "a": 622,
    "b": "Becton Dickinson",
    "c": "Dallas",
    "d": "Liberator Medical Supply - Business Development",
    "e": 5950,
    "f": "Liberator Medical Supply - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-29",
    "i": "6:Delivery",
    "j": 4450,
    "k": "Mario DiMattia",
    "l": 3301,
    "m": "Cristina Niver",
    "n": 3301,
    "o": "Cristina Niver",
    "p": true,
    "q": "",
    "r": "CRED-P00100537",
    "t": "1.13"
},
{
    "a": 244,
    "b": "Stuller",
    "c": "Dallas",
    "d": "Stuller - Business Development",
    "e": 5706,
    "f": "Stuller - Business Development",
    "g": "2022-01-01",
    "h": "2024-11-30",
    "i": "6:Delivery",
    "j": 3381,
    "k": "Gail Stout Perry",
    "l": 3381,
    "m": "Gail Stout Perry",
    "n": 3442,
    "o": "Jason Goth",
    "p": true,
    "q": "",
    "r": "R1810-001",
    "t": "1.4"
},
{
    "a": 802,
    "b": "Triumph Business Capital",
    "c": "Dallas",
    "d": "Triumph Business Capital - Business Development",
    "e": 5451,
    "f": "Triumph Business Capital - Business Development",
    "g": "2022-01-01",
    "h": "2023-10-25",
    "i": "6:Delivery",
    "j": 3762,
    "k": "Pete Gekas",
    "l": 3762,
    "m": "Pete Gekas",
    "n": 3762,
    "o": "Pete Gekas",
    "p": true,
    "q": "",
    "r": "R1366-001",
    "t": "1.7"
},
{
    "a": 844,
    "b": "HomeSafe Alliance",
    "c": "Dallas",
    "d": "HomeSafe Alliance - Business Development",
    "e": 5708,
    "f": "HomeSafe Alliance - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 3886,
    "k": "Simon Saugier",
    "l": 3886,
    "m": "Simon Saugier",
    "n": 3886,
    "o": "Simon Saugier",
    "p": true,
    "q": "",
    "r": "CRED-P00103536",
    "t": "1.17"
},
{
    "a": 118,
    "b": "Gold's Gym",
    "c": "Dallas",
    "d": "Gold's Gym - Business Development",
    "e": 5453,
    "f": "Gold's Gym - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-13",
    "i": "6:Delivery",
    "j": 3762,
    "k": "Pete Gekas",
    "l": 3762,
    "m": "Pete Gekas",
    "n": 3762,
    "o": "Pete Gekas",
    "p": true,
    "q": "",
    "r": "R1305-001",
    "t": "1.6"
},
{
    "a": 36,
    "b": "Brinker International",
    "c": "Dallas",
    "d": "Brinker International - Business Development",
    "e": 5710,
    "f": "Brinker International - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 3886,
    "k": "Simon Saugier",
    "l": 3886,
    "m": "Simon Saugier",
    "n": 3886,
    "o": "Simon Saugier",
    "p": true,
    "q": "",
    "r": "R1273-001",
    "t": "1.20"
},
{
    "a": 753,
    "b": "Pfizer",
    "c": "New York City",
    "d": "Pfizer - Business Development",
    "e": 5970,
    "f": "Pfizer - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-23",
    "i": "6:Delivery",
    "j": 3871,
    "k": "Seema Desai",
    "l": 3871,
    "m": "Seema Desai",
    "n": 3871,
    "o": "Seema Desai",
    "p": true,
    "q": "",
    "r": "R1340-001",
    "t": "1.19"
},
{
    "a": 692,
    "b": "Novata",
    "c": "New York City",
    "d": "Novata - Business Development",
    "e": 5974,
    "f": "Novata - Business Development",
    "g": "2022-01-01",
    "h": "2024-10-22",
    "i": "6:Delivery",
    "j": 3717,
    "k": "Nate Raymond",
    "l": 3717,
    "m": "Nate Raymond",
    "n": 3717,
    "o": "Nate Raymond",
    "p": true,
    "q": "",
    "r": "R1333-001",
    "t": "1.12"
},
{
    "a": 134,
    "b": "Hilton Worldwide",
    "c": "Dallas",
    "d": "Hilton Worldwide - Business Development",
    "e": 5719,
    "f": "Hilton Worldwide - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-31",
    "i": "7:Adjust Rates",
    "j": 3283,
    "k": "Cody Case",
    "l": 3283,
    "m": "Cody Case",
    "n": 3283,
    "o": "Cody Case",
    "p": true,
    "q": "",
    "r": "R1800-001",
    "t": "1.6"
},
{
    "a": 914,
    "b": "Adobe, Inc.",
    "c": "San Francisco Bay Area",
    "d": "Adobe - Business Development",
    "e": 5975,
    "f": "Adobe - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-28",
    "i": "6:Delivery",
    "j": 3717,
    "k": "Nate Raymond",
    "l": 3717,
    "m": "Nate Raymond",
    "n": 3717,
    "o": "Nate Raymond",
    "p": true,
    "q": "",
    "r": "R1254-001",
    "t": "1.10"
},
{
    "a": 431,
    "b": "ExxonMobil",
    "c": "Houston",
    "d": "ExxonMobil - Business Development",
    "e": 5976,
    "f": "ExxonMobil - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 3717,
    "k": "Nate Raymond",
    "l": 3717,
    "m": "Nate Raymond",
    "n": 3717,
    "o": "Nate Raymond",
    "p": true,
    "q": "",
    "r": "R1300-001",
    "t": "1.3"
},
{
    "a": 238,
    "b": "Southwest Airlines",
    "c": "Dallas",
    "d": "Southwest Airlines - Business Development",
    "e": 5727,
    "f": "Southwest Airlines - Business Development",
    "g": "2022-01-01",
    "h": "2026-02-03",
    "i": "6:Delivery",
    "j": 3131,
    "k": "Andrew Stewart",
    "l": 4142,
    "m": "Caitlin Kernander",
    "n": 3131,
    "o": "Andrew Stewart",
    "p": true,
    "q": "",
    "r": "R1357-001",
    "t": "1.13"
},
{
    "a": 761,
    "b": "HBO Max",
    "c": "Los Angeles",
    "d": "HBO Max - Business Development",
    "e": 5728,
    "f": "HBO Max - Business Development",
    "g": "2022-01-01",
    "h": "2024-05-23",
    "i": "6:Delivery",
    "j": 3131,
    "k": "Andrew Stewart",
    "l": 3131,
    "m": "Andrew Stewart",
    "n": 3131,
    "o": "Andrew Stewart",
    "p": true,
    "q": "",
    "r": "R1309-001",
    "t": "1.19"
},
{
    "a": 136,
    "b": "HomeAdvisor",
    "c": "Denver",
    "d": "HomeAdvisor - Business Development",
    "e": 5986,
    "f": "HomeAdvisor - Business Development",
    "g": "2022-01-01",
    "h": "2024-10-03",
    "i": "6:Delivery",
    "j": 3511,
    "k": "Jordan Powell",
    "l": 3511,
    "m": "Jordan Powell",
    "n": 3511,
    "o": "Jordan Powell",
    "p": false,
    "q": "",
    "r": "R1311-001",
    "t": "1.12"
},
{
    "a": 478,
    "b": "Eli Lilly",
    "c": "Dallas",
    "d": "Eli Lilly - Business Development",
    "e": 5988,
    "f": "Eli Lilly - Business Development",
    "g": "2022-01-01",
    "h": "2026-12-31",
    "i": "6:Delivery",
    "j": 3511,
    "k": "Jordan Powell",
    "l": 3511,
    "m": "Jordan Powell",
    "n": 3511,
    "o": "Jordan Powell",
    "p": true,
    "q": "",
    "r": "R1295-001",
    "t": "1.2"
},
{
    "a": 632,
    "b": "Dave and Busters",
    "c": "Dallas",
    "d": "Dave and Busters - Business Development",
    "e": 5989,
    "f": "Dave and Busters - Business Development",
    "g": "2022-01-01",
    "h": "2024-12-31",
    "i": "6:Delivery",
    "j": 3511,
    "k": "Jordan Powell",
    "l": 3475,
    "m": "Jim Nadalini",
    "n": 3511,
    "o": "Jordan Powell",
    "p": false,
    "q": "",
    "r": "R1290-001",
    "t": "1.1"
},
{
    "a": 801,
    "b": "Drake Quantous, LLC",
    "c": "Dallas",
    "d": "Quantous - Business Development",
    "e": 5990,
    "f": "Quantous - Business Development",
    "g": "2022-01-01",
    "h": "2024-02-05",
    "i": "6:Delivery",
    "j": 3511,
    "k": "Jordan Powell",
    "l": 3511,
    "m": "Jordan Powell",
    "n": 3511,
    "o": "Jordan Powell",
    "p": true,
    "q": "",
    "r": "R1346-001",
    "t": "1.6"
},
{
    "a": 743,
    "b": "NEOGOV",
    "c": "Los Angeles",
    "d": "NEOGOV - Business Development",
    "e": 5992,
    "f": "NEOGOV - Business Development",
    "g": "2022-01-01",
    "h": "2024-03-27",
    "i": "6:Delivery",
    "j": 3511,
    "k": "Jordan Powell",
    "l": 3511,
    "m": "Jordan Powell",
    "n": 3511,
    "o": "Jordan Powell",
    "p": true,
    "q": "",
    "r": "R1331-001",
    "t": "1.13"
},
{
    "a": 758,
    "b": "Phood Solutions Inc",
    "c": "New York City",
    "d": "Phood Solutions Inc - Business Development",
    "e": 5993,
    "f": "Phood Solutions Inc - Business Development",
    "g": "2022-01-01",
    "h": "2024-10-07",
    "i": "6:Delivery",
    "j": 3511,
    "k": "Jordan Powell",
    "l": 3511,
    "m": "Jordan Powell",
    "n": 3511,
    "o": "Jordan Powell",
    "p": true,
    "q": "",
    "r": "R1342-001",
    "t": "1.13"
},
{
    "a": 88,
    "b": "EmployBridge",
    "c": "Atlanta",
    "d": "EmployBridge - Business Development",
    "e": 5749,
    "f": "EmployBridge - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-29",
    "i": "6:Delivery",
    "j": 3807,
    "k": "Rick Gipson",
    "l": 3807,
    "m": "Rick Gipson",
    "n": 3807,
    "o": "Rick Gipson",
    "p": true,
    "q": "",
    "r": "R1297-001",
    "t": "1.14"
},
{
    "a": 797,
    "b": "BGSF, Inc.",
    "c": "Dallas",
    "d": "BG Staffing, Inc. - Business Development",
    "e": 5750,
    "f": "BG Staffing, Inc. - Business Development",
    "g": "2022-01-01",
    "h": "2024-09-26",
    "i": "6:Delivery",
    "j": 3807,
    "k": "Rick Gipson",
    "l": 3807,
    "m": "Rick Gipson",
    "n": 3807,
    "o": "Rick Gipson",
    "p": true,
    "q": "",
    "r": "R1270-001",
    "t": "1.6"
},
{
    "a": 803,
    "b": "UCB Pharma",
    "c": "Dallas",
    "d": "UCB Pharma - Business Development",
    "e": 5753,
    "f": "UCB Pharma - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-17",
    "i": "6:Delivery",
    "j": 3435,
    "k": "James Robertson",
    "l": 3435,
    "m": "James Robertson",
    "n": 3454,
    "o": "Jeff Hewitt",
    "p": true,
    "q": "",
    "r": "R1814-001",
    "t": "1.17"
},
{
    "a": 723,
    "b": "Jostens, Inc.",
    "c": "Chicago",
    "d": "Jostens, Inc. - Business Development",
    "e": 5498,
    "f": "Jostens, Inc. - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 4907,
    "k": "Rich Paterson",
    "l": 4907,
    "m": "Rich Paterson",
    "n": 4907,
    "o": "Rich Paterson",
    "p": true,
    "q": "",
    "r": "R1316-001",
    "t": "1.7"
},
{
    "a": 799,
    "b": "GlaxoSmithKline",
    "c": "Dallas",
    "d": "GlaxoSmithKline - Business Development",
    "e": 5754,
    "f": "GlaxoSmithKline - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-28",
    "i": "6:Delivery",
    "j": 3435,
    "k": "James Robertson",
    "l": 3435,
    "m": "James Robertson",
    "n": 3454,
    "o": "Jeff Hewitt",
    "p": true,
    "q": "",
    "r": "R1815-001",
    "t": "1.20"
},
{
    "a": 441,
    "b": "Mars, Inc.",
    "c": "Chicago",
    "d": "Mars, Inc. - Business Development",
    "e": 5499,
    "f": "Mars, Inc. - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 4907,
    "k": "Rich Paterson",
    "l": 4907,
    "m": "Rich Paterson",
    "n": 4907,
    "o": "Rich Paterson",
    "p": true,
    "q": "",
    "r": "R1322-001",
    "t": "1.2"
},
{
    "a": 800,
    "b": "Banfield",
    "c": "Dallas",
    "d": "Banfield - Business Development",
    "e": 5755,
    "f": "Banfield - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-29",
    "i": "6:Delivery",
    "j": 3807,
    "k": "Rick Gipson",
    "l": 3807,
    "m": "Rick Gipson",
    "n": 3807,
    "o": "Rick Gipson",
    "p": true,
    "q": "",
    "r": "CRED-P00100044",
    "t": "1.8"
},
{
    "a": 15,
    "b": "Amgen",
    "c": "Los Angeles",
    "d": "Amgen - Business Development",
    "e": 6267,
    "f": "Amgen - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-04",
    "i": "6:Delivery",
    "j": 3454,
    "k": "Jeff Hewitt",
    "l": 3454,
    "m": "Jeff Hewitt",
    "n": 3957,
    "o": "Trent Sutton",
    "p": true,
    "q": "",
    "r": "R1262-001",
    "t": "1.4"
},
{
    "a": 762,
    "b": "Black Hills",
    "c": "Denver",
    "d": "Black Hills - Business Development",
    "e": 5500,
    "f": "Black Hills - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-29",
    "i": "6:Delivery",
    "j": 4907,
    "k": "Rich Paterson",
    "l": 4907,
    "m": "Rich Paterson",
    "n": 4907,
    "o": "Rich Paterson",
    "p": true,
    "q": "",
    "r": "R1271-001",
    "t": "1.18"
},
{
    "a": 725,
    "b": "Apple",
    "c": "San Francisco Bay Area",
    "d": "Apple - Business Development",
    "e": 5501,
    "f": "Apple - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-29",
    "i": "6:Delivery",
    "j": 4391,
    "k": "Aparna Raman",
    "l": 4391,
    "m": "Aparna Raman",
    "n": 4391,
    "o": "Aparna Raman",
    "p": true,
    "q": "",
    "r": "R1265-001",
    "t": "1.7"
},
{
    "a": 739,
    "b": "SnapLogic",
    "c": "San Francisco Bay Area",
    "d": "Snaplogic - Business Development",
    "e": 5502,
    "f": "Snaplogic - Business Development",
    "g": "2022-01-01",
    "h": "2024-05-30",
    "i": "6:Delivery",
    "j": 4891,
    "k": "Ben Rhodes",
    "l": 4891,
    "m": "Ben Rhodes",
    "n": 4891,
    "o": "Ben Rhodes",
    "p": true,
    "q": "",
    "r": "R1355-001",
    "t": "1.11"
},
{
    "a": 902,
    "b": "Google Inc.",
    "c": "San Francisco Bay Area",
    "d": "Alphabet Inc. (Google) - Business Development",
    "e": 5504,
    "f": "Alphabet Inc. (Google) - Business Development",
    "g": "2022-01-01",
    "h": "2024-04-12",
    "i": "6:Delivery",
    "j": 5243,
    "k": "Steve Ackert",
    "l": 5243,
    "m": "Steve Ackert",
    "n": 4891,
    "o": "Ben Rhodes",
    "p": false,
    "q": "",
    "r": "R1259-001",
    "t": "1.9"
},
{
    "a": 798,
    "b": "Motion Recruitment Partners LLC",
    "c": "Dallas",
    "d": "Motion Recruitment Partners - Business Development",
    "e": 5763,
    "f": "Motion Recruitment Partners - Business Development",
    "g": "2022-01-01",
    "h": "2024-06-16",
    "i": "6:Delivery",
    "j": 3807,
    "k": "Rick Gipson",
    "l": 3807,
    "m": "Rick Gipson",
    "n": 3807,
    "o": "Rick Gipson",
    "p": true,
    "q": "",
    "r": "R1328-001",
    "t": "1.20"
},
{
    "a": 388,
    "b": "LocumTenens.com",
    "c": "Atlanta",
    "d": "LocumTenens.com - Business Development",
    "e": 5764,
    "f": "LocumTenens.com - Business Development",
    "g": "2022-01-01",
    "h": "2026-01-31",
    "i": "6:Delivery",
    "j": 3807,
    "k": "Rick Gipson",
    "l": 3807,
    "m": "Rick Gipson",
    "n": 3807,
    "o": "Rick Gipson",
    "p": true,
    "q": "",
    "r": "R1320-001",
    "t": "1.20"
}
]
};

export default mockApiResponses;
